import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "SportsSelfExcludedLayout" */ './SportsSelfExcludedLayout'),
  modules: ['./SportsSelfExcludedLayout'],
  loading: () => null
});

export default LoadableWidget;
